module.exports = __webpack_public_path__ + "img/bg-1920.b93ae018.webp";